import { createSlice } from "@reduxjs/toolkit";
import { AreeState } from "../types/state";
import { LOADING } from "../../../types";
import { setAreeError } from "../actions/setError";
import { setAreeData } from "../actions/setData";
import { addArea } from "../actions/add";
import { deleteArea } from "../actions/delete";
import { toggleAreaVisibility } from "../actions/toggleVisibility";
import { editArea } from "../actions/edit";

const initialState: AreeState = {
  data: null,
  loading: LOADING.IDLE,
  error: null,
};

export const areeSlice = createSlice({
  name: "aree",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setAreeError, (state, { payload: error }) => {
        state.error = error;
        state.loading = LOADING.IDLE;
        state.data = null;
      })
      .addCase(setAreeData, (state, { payload: sponsors }) => {
        state.data = sponsors;
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addArea.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(addArea.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(addArea.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(editArea.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(editArea.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(editArea.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(deleteArea.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(deleteArea.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(deleteArea.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      })
      .addCase(toggleAreaVisibility.fulfilled, (state) => {
        state.error = null;
        state.loading = LOADING.IDLE;
      })
      .addCase(toggleAreaVisibility.rejected, (state, { payload: error }) => {
        state.loading = LOADING.IDLE;
        state.error = error as string | null;
      })
      .addCase(toggleAreaVisibility.pending, (state) => {
        state.loading = LOADING.PENDING;
        state.error = null;
      });
  },
});
